export default __webpack_public_path__ + "img/0fcb02d9e0d96d911e00789077a00275.svg";